import React from "react";
import { Box, Typography } from "@mui/material";
import SingleSelect from "../Selectors/SingleSelect";
import {
  applyRetailerSelection,
  loadRetailerWorkspaceSelectionOptions,
  userTypeCanUseRetailerSelection,
} from "../../../api_calls/retailerSelection";
import { checkUserDetailsFromCookie } from "../../../api_calls/userManagement";
import { toast } from "react-toastify";

/**
 * Bottom-nav retailer filter. Changing the value switches the workspace so
 * every request that follows is scoped to the chosen retailer.
 */
const RetailerSelectionFilter = ({
  elemId,
  filterSelectionReduxKey,
  flipDropdownOpening,
}) => {
  const label = "Retailer Filter";
  const [retailerSelectionOptions, setRetailerSelectionOptions] = React.useState([]);
  const [selectedRetailer, setSelectedRetailer] = React.useState({});
  const [selectionInProgress, setSelectionInProgress] = React.useState(false);
  const checkUserDetails = checkUserDetailsFromCookie();
  const userDetail = checkUserDetails.success === true ? checkUserDetails.user_detail : {}
  const normalizedUserType = typeof userDetail.user_type !== "undefined" ? userDetail.user_type.toLowerCase() : "";
  const renderRetailerFilter = userTypeCanUseRetailerSelection(normalizedUserType);

  const loadRetailerSelectionFilter = React.useCallback(async () => {

    if (renderRetailerFilter === false) {
      setRetailerSelectionOptions([]);
      setSelectedRetailer({});
      return;
    }

    const retailerSelectionInfo = await loadRetailerWorkspaceSelectionOptions(filterSelectionReduxKey);

    if (retailerSelectionInfo.success === true) {
      setRetailerSelectionOptions(retailerSelectionInfo.options);
      setSelectedRetailer(retailerSelectionInfo.selected_option);
    }
  }, [filterSelectionReduxKey, renderRetailerFilter]);

  React.useEffect(() => {
    loadRetailerSelectionFilter();
  }, [loadRetailerSelectionFilter]);

  if (retailerSelectionOptions.length === 1) {
    return (
      <Box sx={{ maxWidth: "220px", width: "100%", textAlign: "left" }}>
        <Typography variant="caption" sx={{ color: "#AF3241", display: "block", lineHeight: 1.1 }}>
          {label}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: "#2D2D37",
            fontWeight: "bold",
            overflowWrap: "anywhere",
          }}
        >
          {selectedRetailer.label}
        </Typography>
      </Box>
    );
  }

  return retailerSelectionOptions.length > 1 ? (
    <SingleSelect
      enableFullWidth={false}
      elemId={elemId}
      label={label}
      options={retailerSelectionOptions}
      defaultVal={typeof selectedRetailer !== "undefined" && typeof selectedRetailer.value !== "undefined" ? selectedRetailer : retailerSelectionOptions[0]}
      selectionCheck={(option, value) => option.value === value.value}
      disableSearch={true}
      sortOptions={false}
      flip={typeof flipDropdownOpening !== "undefined" ? flipDropdownOpening : true}
      onChangeCall={async (selectedOption) => {
        if (selectionInProgress === true || selectedOption.value === selectedRetailer.value) return;

        try {
          setSelectionInProgress(true);

          const retailerSelectionInfo = await applyRetailerSelection(filterSelectionReduxKey, selectedOption);

          if (
            typeof retailerSelectionInfo.success !== "undefined" &&
            retailerSelectionInfo.success === true
          ) {
            setSelectedRetailer(retailerSelectionInfo.selected_option);
            return;
          }

          toast("Sorry, something went wrong.", { type: "error" });
        } catch {
          toast("Sorry, something went wrong.", { type: "error" });
        } finally {
          setSelectionInProgress(false);
        }
      }}
    />
  ) : null;
};

export default RetailerSelectionFilter;
